import { Component, Input, OnChanges } from '@angular/core';
import {
  ApexChart,
  ApexDataLabels,
  ApexLegend,
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexTooltip
} from "ng-apexcharts";

import { SharedService } from '@app/core';

type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  colors: string[];
  legend: ApexLegend;
  dataLabels: ApexDataLabels;
  tooltip: ApexTooltip;
};

@Component({
  selector: 'app-donut-chart',
  templateUrl: './donut.component.html',
  styleUrls: ['./donut.component.scss']
})
export class DonutChartComponent implements OnChanges {
  @Input() series: {};
  public chartOptions: Partial<ChartOptions>;

  constructor(private sharedService: SharedService) { }

  ngOnChanges() {
    this.chartOptions = {
      series: this.series ? Object.values(this.series) : [],
      chart: {
        type: "donut"
      },
      labels: this.series ? Object.keys(this.series) : [],
      tooltip: {
        y: {
          formatter: (value: any) => this.sharedService.formatNumber(value, false, 0, 2, true)
        }
      },
      colors: ['#339DE1', '#EBB901', '#D97983'],
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      responsive: [
        {
          breakpoint: 2560,
          options: {
            chart: {
              width: 320,
            },
            legend: {
              position: "bottom",
              show: false
            }
          }
        },
        {
          breakpoint: 1280,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: "bottom",
              show: false
            }
          }
        },
        {
          breakpoint: 991,
          options: {
            chart: {
              width: 250
            },
            legend: {
              position: "bottom",
              show: false
            }
          }
        }
      ]
    };
  }
}